import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { ProductCreateWfoodcostInfoPage } from "../product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info";
import { ProductCreateFoodcostInfoPage } from "../product-create-foodcost/product-create-foodcost-info/product-create-foodcost-info";
import { Globals } from '../../../../globals';
import { HttpParams, HttpClient } from '@angular/common/http';

/**
 * Generated class for the ProductCreateSelectTypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-create-select-type',
    templateUrl: 'product-create-select-type.html',
})
export class ProductCreateSelectTypePage {

    type: any = "";
    license_access: boolean = true;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public http: HttpClient) {

    }

    async ionViewWillEnter() {
        let limit = this.globals.checkLimitsByLicense('stock', 'ings_prods')
        if (limit >= 0) {
            const params = new HttpParams()
                .set('uid', this.globals.restaurant_uid)
                .set('elements_per_page', limit)
                .set('limit', limit);
            await this.http.post(this.globals.analytics_path + 'paginate/limited_products', params, {})
                .subscribe(async res => {

                    if (res['list'].length >= limit) {
                        this.license_access = false;
                    }
                });

        }
    }

    select(type) {
        this.type = type;
    }

    selected() {
        this.type = "";
    }

    checkState(type) {
        if (this.type == type) {
            return true
        } else {
            return false
        }
    }

    openProductTitles() {

        if (this.type != '') {
            this.globals.GAtrackView('Products', 'Products - Select type - Create', this.globals.restaurant.email, 'Create/Update', 'Create select type', 'Products', this.type);

            if (this.type == 'foodcost') {
                this.navCtrl.push(ProductCreateFoodcostInfoPage, {
                    type: this.type,
                });
            } else {
                this.navCtrl.push(ProductCreateWfoodcostInfoPage, {
                    type: this.type,
                });
            }


        }

    }

}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-select-type/product-create-select-type.ts